module.exports = __webpack_public_path__ + "img/cellfast-logo.28befd4a.png";